import { SvgIcon } from '@mui/material'
import { env } from 'config'
import { MICROSOFT_PROVIDER_ID, OAuthProviderId } from 'shared/utils'

export const MicrosoftIcon = () => (
  <SvgIcon viewBox="0 0 21 21" fontSize="small">
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </SvgIcon>
)

export interface OAuthProviderConfig {
  providerId: OAuthProviderId
  // A brand name, the same in every language
  name: string
  labelKey: string
  pendingLabelKey: string
  Icon: () => JSX.Element
  showOnEmailForm: boolean
}

export const OAUTH_PROVIDERS: OAuthProviderConfig[] = [
  ...(!env.hideMicrosoftAuth
    ? [
        {
          providerId: MICROSOFT_PROVIDER_ID,
          name: 'Microsoft',
          labelKey: 'login.signInWithMicrosoft',
          pendingLabelKey: 'login.signInWithMicrosoftPending',
          Icon: MicrosoftIcon,
          showOnEmailForm: true,
        },
      ]
    : []),
]

export const getOAuthProviders = () => OAUTH_PROVIDERS

export const getEmailFormOAuthProviders = () =>
  getOAuthProviders().filter(provider => provider.showOnEmailForm)

export const getOAuthProvidersForMethods = (methods: string[]) =>
  getOAuthProviders().filter(provider => methods.includes(provider.providerId))
